import { DesignSystem, ModalViews } from "@vana/core";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import { AuthProvider } from "../../auth/auth-context";
import { store } from "../../redux/store";
import { router } from "./router";

export const App = () => (
  <Provider store={store}>
    <AuthProvider>
      <RouterProvider router={router} />
      <ModalViews />
      <DesignSystem />
    </AuthProvider>
  </Provider>
);
